import { useScope } from "~/hooks/useScope";
import { OrganizationPoliciesPage } from "~/pages/organization/policies/OrganizationPoliciesPage";

export function OrganizationPoliciesEntryPage() {
  const { organizationScope } = useScope();
  return organizationScope ? (
    <OrganizationPoliciesPage scope={organizationScope} />
  ) : undefined;
}
